import { useSelector } from 'react-redux'

import styles from './TaxInfoDialog.module.scss'

const EinHelpText = ({ province, isCanadian }) => {
  const cultureCode = useSelector(s => s.hotelDetails.cultureCode)

  if (isCanadian || cultureCode === 'en-CA') {
    return (
      <div className={styles.help}>
        <h4>What is the Canadian Corporation Number?</h4>This number can be may be federal
        or provincial. Please do NOT enter your business number or federal tax ID number,
        as that is not readily cross-referenced.
        <br />
        <br />
        <a
          href="https://beta.canadasbusinessregistries.ca/search"
          target="_blank"
          rel="noreferrer"
        >
          Find your business in Canada Business Registries{' '}
        </a>
        <br />
        {province === 'ON' && (
          <a
            href="https://www.appmybizaccount.gov.on.ca/onbis/master/viewInstance/view.pub?id=3abd3bce3cc0ad2aa8a02e89f13ba26956db547a6d015cc8&_timestamp=3234734835852443"
            target="_blank"
            rel="noreferrer"
          >
            Find your Ontario Corporation Number
          </a>
        )}
      </div>
    )
  } else {
    return (
      <div className={styles.help}>
        <h4>What is the Employer Identification Number?</h4>
        EIN is a nine-digit number (for example, 12-3456789) used to identify a business
        entity.{' '}
        <a
          href="https://www.irs.gov/businesses/small-businesses-self-employed/employer-id-numbers"
          target="_blank"
          rel="noreferrer"
        >
          Learn more on IRS website.
        </a>
      </div>
    )
  }
}

export default EinHelpText
